import { type Agency } from '../../../common/types';
import ListAgencyItem from './ListAgencyItem';

interface IProps {
  items: Agency[];
  filter?: { pending: boolean };
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  toggleApproveModal: () => any;
  handleEditingItem: (item: Agency) => any;
  handleDeletingItem: (item: Agency) => any;
  handleApprovingItem: (item: Agency) => any;
}

const ListAgencies: React.FC<IProps> = ({
  items,
  toggleEditModal,
  toggleDeleteModal,
  toggleApproveModal,
  handleEditingItem,
  handleDeletingItem,
  handleApprovingItem
}) => {
  return (
    <>
      <div className="w-full p-2 my-2 overflow-auto rounded-md">
        <table className="w-full border-b-2 border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 pl-8 text-sm font-semibold text-left tracking-wide">Fullname</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Identifier</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Email</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Phone</th>
              <th className="p-2 text-sm font-semibold text-left tracking-wide">Status</th>
              <th className="w-12 p-2 pr-8 text-sm font-semibold tracking-wide">Actions</th>
            </tr>
          </thead>
          <tbody className="">
            {items.map((item) => {
              return (
                <ListAgencyItem
                  item={item}
                  key={item.id}
                  toggleEditModal={toggleEditModal}
                  toggleDeleteModal={toggleDeleteModal}
                  toggleApproveModal={toggleApproveModal}
                  handleEditingItem={handleEditingItem}
                  handleDeletingItem={handleDeletingItem}
                  handleApprovingItem={handleApprovingItem}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListAgencies;
